import { MATURITY_LABELS, PATH_LABELS } from './constants'
import type { Stats } from './constants'

interface Props {
  stats: Stats
}

export default function StatsCards({ stats }: Props) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-card border border-border rounded-lg p-4">
        <p className="text-xs text-muted-foreground uppercase tracking-wider">Total de Respostas</p>
        <p className="text-2xl font-bold text-foreground mt-1">{stats.total}</p>
      </div>

      <div className="bg-card border border-border rounded-lg p-4">
        <p className="text-xs text-muted-foreground uppercase tracking-wider">Maturidade Média</p>
        <p className="text-2xl font-bold text-foreground mt-1">
          {stats.avgMaturity}
          {stats.total > 0 && (
            <span className="text-sm font-normal text-muted-foreground ml-2">
              {MATURITY_LABELS[Math.round(stats.avgMaturity)] ?? ''}
            </span>
          )}
        </p>
      </div>

      <div className="bg-card border border-border rounded-lg p-4">
        <p className="text-xs text-muted-foreground uppercase tracking-wider">Por Caminho</p>
        <div className="mt-1 space-y-1">
          {Object.entries(stats.byPath).map(([path, count]) => (
            <div key={path} className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">{PATH_LABELS[path] ?? path}</span>
              <span className="font-medium text-foreground">{count}</span>
            </div>
          ))}
          {Object.keys(stats.byPath).length === 0 && (
            <p className="text-sm text-muted-foreground">—</p>
          )}
        </div>
      </div>

      <div className="bg-card border border-border rounded-lg p-4">
        <p className="text-xs text-muted-foreground uppercase tracking-wider">Por Nível</p>
        <div className="mt-1 space-y-1">
          {[1, 2, 3, 4, 5].map((level) => (
            <div key={level} className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">{level} — {MATURITY_LABELS[level]}</span>
              <span className="font-medium text-foreground">{stats.byLevel[level] ?? 0}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
